<template>
	<inertia-head title="Marketing Images" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Marketing Images</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Welcome to TRC Admin Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="text-end mb-4">
			<button @click="viewMarketingImageContentModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add Marketing Image
			</button>
		</div>
		<div class="block">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					<div class="input-group">
						<form @submit.prevent="searchRecord">
						<input v-model="search" type="text" id="search" name="search" class="form-control" placeholder="Marketing Image Search">
					</form>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table class="table table-borderless table-striped table-vcenter">
						<thead>
							<tr>
								<th>Title</th>
								<th>Description</th>
								<th>Category</th>
								<th>Image</th>
								<th>Status</th>
								<th>Date Created</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(image, index) in marketingImages.data" :key="index">
								<td>{{ image.title }}</td>
								<td>{{ image.description }}</td>
								<td>{{ image.category }}</td>
								<td>{{ image.image }}</td>
								<td>{{ image.status }}</td>
								<td>{{ image.date_created }}</td>
								<td nowrap="" class="text-end">
									<button @click="viewMarketingImageContentModal(index,'update')" type="button" class="btn btn-alt-info btn-sm me-1"><i class="fa fa-pencil-alt"></i></button>
									<button @click="confirmDelete(index)" type="button" class="btn btn-alt-danger btn-sm"><i class="fa fa-times"></i></button>
								</td>
							</tr>
							<tr v-if="marketingImages.data.length <= 0">
								<td colspan="7">
									<p class="mb-0 fw-semibold text-danger">NO MARKETING IMAGE FOUND</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination :collections="marketingImages" />
			</div>
		</div>

		<add-update-marketing-image-modal ref="addUpdateMarketingImageModal"/>


		<modal ref="deleteModal">
		<template #title>DELETE CONFIRMATION</template>
		<template #body>
			<div class="text-center">
                <p class="h6">
                    Are you sure, you want to delete this data?
                </p>
            </div>
		</template>
		<template #footer>
			<button type="button" @click="deleteMarketingImage()" class="btn btn-alt-primary btn-sm"><i class="fa fa-check-circle"></i> YES</button>
            <button @click="deleteModal.toggleModal" type="button" id="btnDeleteClose" class="btn btn-alt-danger btn-sm"><i class="fa fa-times-circle"></i> NO</button>
		</template>
	</modal>

	</div>
</template>

<script>
import { watch, onMounted, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import AddUpdateMarketingImageModal from '../../../Components/Admin/AffiliateProgram/AddUpdateMarketingImageModal'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia'

export default {
	layout: AuthLayout,
	props: {
		marketingImages: Object,
	},
	components:{AddUpdateMarketingImageModal},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const search = ref(props.search??'');
		const action = ref('add');

		const cur_index = ref(null);

		const deleteModal 					= ref(null);
		const addUpdateMarketingImageModal 	= ref(null);

		const selectedMarketingImageContent = reactive({});

		const confirmDelete = (_index)=>{
			cur_index.value = _index;
			deleteModal.value.toggleModal();
		}

		const viewMarketingImageContentModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedMarketingImageContent.id 				= props.marketingImages.data[_index].id;
				selectedMarketingImageContent.category 			= props.marketingImages.data[_index].category;
				selectedMarketingImageContent.title 			= props.marketingImages.data[_index].title;
				selectedMarketingImageContent.description 		= props.marketingImages.data[_index].description;
				selectedMarketingImageContent.image_name 		= props.marketingImages.data[_index].image_name;
				selectedMarketingImageContent.status 			= props.marketingImages.data[_index].status;
			}

			addUpdateMarketingImageModal.value.setMarketingVideoContent(_action,selectedMarketingImageContent);

			addUpdateMarketingImageModal.value.toggleModal();

		}

		const deleteMarketingImage = () => {
			action.value = "delete";
			var id = props.marketingImages.data[cur_index.value].id;

			Inertia.delete('marketing-image/'+id, {
				preserveState: true,
				preserveScroll: true,
				only:['marketingImages,api_response','search'],
				onSuccess: () => {
					deleteModal.value.toggleModal();
				},
			})
		}

		const searchRecord = () => {

							Inertia.get(
								route('admin.affiliate-program.marketing-images'),
								{
									search 		: search.value
								},
								{
									preserveState: true,
									preserveScroll: true,
									only:['marketingImages,api_response','search'],
								}
							)
						}

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='add' ? 'added' : (action.value=='delete' ? 'deleted' : 'updated');

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "error"});
				}
			}
		})

		return{
			search,
			action,
			cur_index,
			searchRecord,
			confirmDelete,
			deleteModal,
			addUpdateMarketingImageModal,
			deleteMarketingImage,
			selectedMarketingImageContent,
			viewMarketingImageContentModal
		}
	},
}
</script>
